import { render, staticRenderFns } from "./FeSwisstex.vue?vue&type=template&id=656b1f22&"
import script from "./FeSwisstex.vue?vue&type=script&lang=js&"
export * from "./FeSwisstex.vue?vue&type=script&lang=js&"
import style0 from "./FeSwisstex.vue?vue&type=style&index=0&id=656b1f22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports